<template>
  <div class="social-networks">
    <a
      v-for="item in items"
      :key="item.name"
      :href="item.url"
      target="_blank"
    >
      <f-sprite-icon :icon-link="$options.icons[`Icon${item.name}`].id" />
    </a>
  </div>
</template>

<script>
import { SOCIAL_NETWORKS } from '@/constants/contacts';

import IconVk from '@icons/vk.svg';
import IconOk from '@icons/ok.svg';
import IconTelegram from '@icons/telegram.svg';

export default {
  name: 'social-networks',

  icons: {
    IconVk,
    IconOk,
    IconTelegram,
  },

  props: {
    items: {
      type: Array,
      default: () => Object.values(SOCIAL_NETWORKS),
    },
  },
};
</script>

<style lang="scss">
.social-networks {
  display: flex;
  height: 40px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $blue;
    color: #fff;
    cursor: pointer;

    & + a {
      margin-left: 12px;
    }
  }

  .sprite-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
